import React from 'react';
import ImgPlaceholderTransparentBackground from '../../../../../../images/ImgPlaceholderTransparentBackground';
import Image from '../../../../../components/Image';

interface FaviconPreviewProps {
    src?: string;
    alt?: string;
}

const FaviconPreview = ({
    src,
    alt = 'Favicon Preview',
}: FaviconPreviewProps) => {
    return (
        <div className='favicon-preview'>
            {src ? (
                <Image
                    useLocalBaseUrl
                    src={src}
                    alt={alt}
                    className='favicon-preview__image'
                />
            ) : (
                <ImgPlaceholderTransparentBackground />
            )}
        </div>
    );
};

export default FaviconPreview;
